import { LoadingButton } from '@mui/lab'
import { C1ButtonProps } from 'c1ui'
import { FC } from 'react'

export type C1LoadingButtonProps = C1ButtonProps & {
  loading?: boolean
  ariaLabel?: string
}

export const C1LoadingButton: FC<C1LoadingButtonProps> = (props) => <LoadingButton {...props} aria-label={props.ariaLabel} />
